import { createRequestId } from './utils/requestId';
import { portalManagePath, portalTokenFromHash } from './utils/portalReturn';

function showMessage(elementId: 'donationSuccessMessage' | 'donationErrorMessage', message: string) {
  const status = document.getElementById('donationStatusMessage')!;
  const success = document.getElementById('donationSuccessMessage')!;
  const error = document.getElementById('donationErrorMessage')!;

  status.classList.remove('hidden');
  success.classList.toggle('hidden', elementId !== 'donationSuccessMessage');
  error.classList.toggle('hidden', elementId !== 'donationErrorMessage');
  document.getElementById(elementId)!.textContent = message;
}

function hideMessages() {
  document.getElementById('donationStatusMessage')!.classList.add('hidden');
  document.getElementById('donationSuccessMessage')!.classList.add('hidden');
  document.getElementById('donationErrorMessage')!.classList.add('hidden');
}

document.addEventListener('DOMContentLoaded', async () => {
  const donationForm = document.getElementById('donationForm') as HTMLFormElement;
  const checkoutButton = document.getElementById('proceedToPaymentButton') as HTMLButtonElement;
  const donorEmailInput = document.getElementById('donorEmail') as HTMLInputElement;
  const donationAmountInput = document.getElementById('donationAmount') as HTMLInputElement;
  const portalRequestLink = document.getElementById('portalRequestLink') as HTMLAnchorElement;
  const verifiedPortalForm = document.getElementById('verifiedPortalForm') as HTMLFormElement;

  const verifiedPortalToken = portalTokenFromHash(window.location.hash);
  if (verifiedPortalToken) {
    verifiedPortalForm.action = portalManagePath(verifiedPortalToken);
    verifiedPortalForm.classList.remove('hidden');
    portalRequestLink.classList.add('hidden');
  }

  const params = new URLSearchParams(window.location.search);
  const requestedDonationType = params.get('type');
  const checkoutSessionId = params.get('checkout_session_id');
  const checkoutResult = params.get('checkout');

  if (checkoutSessionId) {
    let shouldCleanUrl = false;
    try {
      const response = await fetch(
        `/api/checkout-session-status?session_id=${encodeURIComponent(checkoutSessionId)}`,
        { headers: { Accept: 'application/json' } }
      );
      const result = await response.json() as { status?: string };
      if (response.ok && result.status === 'paid') {
        showMessage('donationSuccessMessage', 'Thank you! Your donation was successful. You will receive a confirmation email shortly.');
        shouldCleanUrl = true;
      } else if (response.ok && result.status === 'processing') {
        showMessage('donationSuccessMessage', "Payment processing. We'll update you when payment is received.");
        shouldCleanUrl = true;
      } else if (response.status === 400 || response.status === 404) {
        showMessage('donationErrorMessage', 'Your payment could not be confirmed. Please try again or contact us for help.');
        shouldCleanUrl = true;
      } else {
        showMessage('donationErrorMessage', 'Payment verification is temporarily unavailable. Refresh this page to try again.');
      }
    } catch (error) {
      console.error('Failed to verify Checkout Session:', error);
      showMessage('donationErrorMessage', 'Payment verification is temporarily unavailable. Refresh this page to try again.');
    }
    if (shouldCleanUrl) history.replaceState(null, '', window.location.pathname);
  } else if (checkoutResult === 'canceled') {
    showMessage('donationErrorMessage', 'Your donation was not completed. You can try again when ready.');
  }

  if (requestedDonationType === 'one-time' || requestedDonationType === 'recurring') {
    const requestedRadio = document.querySelector(
      `input[name="donationType"][value="${requestedDonationType}"]`
    ) as HTMLInputElement | null;
    if (requestedRadio) requestedRadio.checked = true;
  }

  let donationRequestId = createRequestId();
  let donationRequestFingerprint = '';

  donationForm.addEventListener('submit', async event => {
    event.preventDefault();
    hideMessages();

    const email = donorEmailInput.value.trim();
    const amount = donationAmountInput.value;
    const selected = document.querySelector('input[name="donationType"]:checked') as HTMLInputElement | null;
    const donationType = selected?.value === 'one-time' ? 'one-time' : 'recurring';

    if (!email || !amount || Number(amount) <= 0) {
      showMessage('donationErrorMessage', 'Please fill in your email and a valid donation amount.');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      showMessage('donationErrorMessage', 'Please enter a valid email address.');
      return;
    }

    const fingerprint = JSON.stringify({ email: email.toLowerCase(), amount, donationType });
    if (fingerprint !== donationRequestFingerprint) {
      donationRequestId = createRequestId();
      donationRequestFingerprint = fingerprint;
    }

    checkoutButton.disabled = true;
    checkoutButton.textContent = 'Opening Secure Checkout...';

    try {
      const response = await fetch('/api/create-donation-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Idempotency-Key': donationRequestId
        },
        body: JSON.stringify({
          name: email.split('@')[0] || 'Donor',
          email,
          amount,
          donationType
        })
      });
      const data = await response.json() as { checkoutUrl?: string; error?: string };
      if (!response.ok || !data.checkoutUrl) {
        showMessage('donationErrorMessage', data.error || 'Could not initialize payment. Please try again.');
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Continue to Secure Checkout';
        return;
      }
      window.location.assign(data.checkoutUrl);
    } catch (error) {
      console.error('Failed to open Stripe Checkout:', error);
      showMessage('donationErrorMessage', 'Payment setup is temporarily unavailable. Please try again.');
      checkoutButton.disabled = false;
      checkoutButton.textContent = 'Continue to Secure Checkout';
    }
  });
});
